const Description = ({ text }) => {
  return <p className="card-description">{text}</p>;
};

export default Description;
